import type { UserListEntry } from "../../api/types";

/**
 * G-136 — the address, plus what is true of it: not yet confirmed by the
 * person, or a new one waiting for its link. Shared by the table and sheet.
 */
export function TeamEmail({ user }: { user: UserListEntry }) {
  return (
    <>
      {user.email}
      {user.accountStatus === "ACTIVE" && user.emailVerified === false ? (
        <span className="muted"> · unconfirmed</span>
      ) : null}
      {user.pendingEmail ? (
        <span className="muted"> · changing to {user.pendingEmail}</span>
      ) : null}
    </>
  );
}
